import React, { useEffect, useRef, useState } from "react";
import "./Row.css";
import Axios from "../../axios";
import YouTube from "react-youtube";
import movieTrailer from "movie-trailer";
const base_url = "https://image.tmdb.org/t/p/original/";

const Row = ({ title, fetchUrl, isLargeRow }) => {
    const [movies, setMovies] = useState([]);
    const [trailerurl, setTrailerUrl] = useState("");
    const scrollRef = useRef();
    const arrowRef = useRef();
    const arrowRef2 = useRef();
    useEffect(() => {
        const fetchData = async () => {
            try {
                const { data } = await Axios.get(fetchUrl);
                setMovies(data.results);
                console.log(data.results);
            } catch (error) {
                console.log(error.message);
            }
        };
        fetchData();
    }, [fetchUrl]);

    let opts = { height: "390", width: "100%", playerVars: { autoplay: 1 } };

    const handleClick = (movie) => {
        if (trailerurl) {
            setTrailerUrl("");
        } else {
            movieTrailer(movie?.name || movie?.title || movie?.original_name || movie?.original_title || "")
                .then((url) => {
                    const urlParams = new URLSearchParams(new URL(url).search);
                    setTrailerUrl(urlParams.get("v"));
                })
                .catch((error) => console.log(error.message));
        }
    };

    const handleScroll = (direction) => {
        if (direction === "left") {
            scrollRef.current.scrollLeft -= 185;
        }
        if (direction === "right") {
            scrollRef.current.scrollLeft += 185;
        }
        // scrollRef.current.style.scrollBehavior = "smooth";
    };

    const handleOver = () => {
        arrowRef.current.style.display = "flex";
        arrowRef2.current.style.display = "flex";
    };
    const handleOut = () => {
        arrowRef.current.style.display = "none";
        arrowRef2.current.style.display = "none";
    };

    return (
        <div className="row">
            <h1>{title}</h1>
            <div style={{ position: "relative" }} onMouseOver={handleOver} onMouseOut={handleOut}>
                <i ref={arrowRef} className="fa-solid fa-chevron-left sliderArrow left fa-2x" onClick={() => handleScroll("left")}></i>
                <div ref={scrollRef} className="row_posters">
                    {movies.map((movie) => (
                        <img key={movie.id} className={`row_poster ${isLargeRow && "row_posterLarge"}`} src={`${base_url}${isLargeRow ? movie.poster_path : movie.backdrop_path}`} alt={movie.name} onClick={() => handleClick(movie)} />
                    ))}
                </div>
                <i ref={arrowRef2} className="fa-solid fa-chevron-right sliderArrow right fa-2x" onClick={() => handleScroll("right")}></i>
            </div>
            <div style={{ padding: "40px" }}>{trailerurl && <YouTube videoId={trailerurl} opts={opts} />}</div>
        </div>
    );
};

export default Row;
